var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pt-12 mt-2 pb-1" },
    [
      _vm._l(4, function (i) {
        return _c(
          "v-row",
          { key: i },
          _vm._l(3, function (i) {
            return _c(
              "v-col",
              { key: i },
              [_c("v-skeleton-loader", { attrs: { type: "card" } })],
              1
            )
          }),
          1
        )
      }),
      _c("v-divider"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }